var XomButtonModule = /** @class */ (function () {
    function XomButtonModule() {
    }
    return XomButtonModule;
}());
export { XomButtonModule };
